var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ig-upload",
      class: _vm.uploadClasses,
      on: {
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.onDragOver.apply(null, arguments)
        },
        dragenter: function ($event) {
          $event.preventDefault()
          return _vm.onDragEnter.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.onDragLeave.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.onDrop.apply(null, arguments)
        },
        paste: _vm.onPaste,
      },
    },
    [
      _c("input", {
        ref: "fileInput",
        staticClass: "ig-upload__file-input",
        attrs: { type: "file", multiple: _vm.multiple, accept: "image/*" },
        on: { change: _vm.onFileChange },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ig-upload__drop",
          class: _vm.dropClasses,
          on: {
            click: function ($event) {
              return _vm.$refs.fileInput.click()
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "ig-upload__icon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("path", {
                attrs: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" },
              }),
              _vm._v(" "),
              _c("polyline", { attrs: { points: "17 8 12 3 7 8" } }),
              _vm._v(" "),
              _c("line", { attrs: { x1: "12", x2: "12", y1: "3", y2: "15" } }),
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "ig-upload__text" }, [
            _vm._v(
              "\n      Drag & drop images here, paste from clipboard, or\n      "
            ),
            _c(
              "button",
              {
                staticClass: "ig-upload__browse",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.$refs.fileInput.click()
                  },
                },
              },
              [_vm._v("\n        browse\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.images.length
        ? _c(
            "div",
            { staticClass: "ig-upload__grid" },
            _vm._l(_vm.images, function (item) {
              return _c(
                "div",
                {
                  key: item._localId,
                  staticClass: "ig-upload__thumb group/img",
                },
                [
                  _c("img", {
                    staticClass: "ig-upload__img",
                    attrs: {
                      src: item._preview || _vm.imageUrl(item),
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ig-upload__remove",
                      attrs: { type: "button", title: "Remove image" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("remove", item)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", { attrs: { d: "M18 6 6 18" } }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "m6 6 12 12" } }),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c(
            "p",
            { staticClass: "ig-upload__error", attrs: { role: "alert" } },
            [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }